/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRemoveCommentMessage extends IMessage {
	commentThreadId: string;
	commentId: string;
	documentId: string;
}

export default class RemoveCommentMessage extends Message {
	public static readonly TYPE: string = '95';

	public static readonly READABLE_TYPE_NAME: string = 'removeComment';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2RemoveCommentMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			commentId: {
				type: 'string',
				id: 2
			},
			documentId: {
				type: 'string',
				id: 3
			}
		}
	};

	public constructor(
		public readonly documentId: string,
		public readonly commentThreadId: string,
		public readonly commentId: string
	) {
		super();
	}

	public toJSON(): IRemoveCommentMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId,
			commentId: this.commentId
		};
	}

	public static fromJSON( object: IRemoveCommentMessage ): RemoveCommentMessage {
		return new RemoveCommentMessage( object.documentId, object.commentThreadId, object.commentId );
	}
}
